  
 <form  [formGroup]="formDialog">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
        Rename
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>      
    </h2>   
    
  <mat-dialog-content class="mat-typography">
    <mat-form-field class="example-full-width">
        <mat-label >{{FileFolderName}}</mat-label>       
        <input matInput [required]="true" maxlength="50" (input)="onChange(formDialog.value)"  placeholder="Add {{FileFolderName}}" formControlName="formFolderName"/>
        <mat-error
        *ngIf="
          formDialog.get('formFolderName').invalid &&
          (formDialog.get('formFolderName').dirty ||
          formDialog.get('formFolderName').touched)">
        <span>This field is mandatory.</span>
      </mat-error>
      </mat-form-field>
  
  
  </mat-dialog-content>
  
  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="disableRename" 
    (click)="renameFileManagerItem(formDialog.value)">Rename
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
  </mat-dialog-actions>
  
    </form>
  
  
  
  
  
  
  
  